/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { FilterContext } from '../contexts';

export const useFilterStore = () => useContext(FilterContext);
